<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import lockIcon from "!!raw-loader!../../images/lock.svg";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin],
  data() {
    return {
      bgVideoActive: false,
    };
  },
  methods: {
    getContentURL: Fandom.getContentURL,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getContentResponsiveImageURL(name) {
      // override
      const imageMobile = this.content[`${name}_mobile`];
      if ((globalState.viewport["sm"] || globalState.viewport["xs"]) && Fandom.exists(imageMobile)) {
        return `url("${imageMobile.url}")`;
      } else if (Fandom.exists(this.content[name])) {
        return `url("${this.content[name].url}")`;
      }
      return null;
    }
  },
  computed: {
    buttonTitle() {
      const buttonTitle = get(this, ["content", "button_title"], this.ft("globals.see_content"));
      return get(this, ["content", "url", "title"], buttonTitle);
    },
    linkLabelClasses() {
      const colors = this.content.theme == "dark" ? "text-white" : "text-primary";
      return this.authorized ? colors : "disabled";
    },
    lockIconClasses() {
      const colors = this.content.theme === "dark" ? "bg-white text-primary" : "bg-primary text-white";
      return [
        colors,
        this.backgroundImage ? "full-right" : ""
      ];
    },
    contentUrl() {
      return this.authorized ? this.getContentURL(this.content) : false;
    },
    backgroundThumbnailImage() {
      if (this.content.thumbnail_wide) {
        return this.getContentResponsiveImageURL('thumbnail_wide');
      }
      if (this.content.thumbnail) {
        return this.getContentResponsiveImageURL('thumbnail');
      }
      return false;
    },
    componentTag() {
      return this.authorized ? "a" : "div";
    },
    lockIcon() {
      return lockIcon;
    },
    isCustomContent() {
      return this.content.button_icon_class || this.content.parent_names.includes('content-type-video');
    },
    iconClass() {
      return this.content.button_icon_class ? this.content.button_icon_class
        : this.content.parent_names.includes('content-type-video') ? 'fas fa-play ml-1 font-base' : 'far fa-chevron-right'
    }
  }
};
</script>

<template>
  <component 
    tile-component
    :style="theme"
    :class="contentType"
    :is="componentTag"
    v-easyadmin="easyadminId" 
    class="position-relative d-block tile-shadow"
    :href="contentUrl"
    :target="getTarget(content.url)"
    v-if="isContentVisibleToUser()"
  >
    <div
      v-if="!authorized"
      class="position-absolute-center locked-layer w-100 h-100 cursor-pointer"
      @click.prevent="mayRedirectOnFreeContent(true)"
      >
    </div>
    <div class="bg-cover-center position-absolute-center background" :style="{'background-image': backgroundThumbnailImage}"></div>
    <div class="d-flex flex-column-reverse flex-md-row tile__content h-100" :class="this.content.theme == 'dark' ? 'text-white' : 'text-dark'">
      <div class="tile__text-section p-4 d-flex flex-column justify-content-between h-100">
        <div>
          <div
            v-if="category"
            class="tile__category small mb-4 d-inline-block px-3 py-1"
            :class="this.content.theme == 'dark' ? 'white' : 'dark'"
          >
            <div class="d-flex align-items-center">
              <img v-if="categoryIcon && categoryIcon.url" :src="categoryIcon.url" class="category-icon mr-2"/> 
              <i v-else-if="categoryIcon" class="fas mr-2" :class="`fa-${categoryIcon}`"></i>
              {{category}}
            </div>
          </div>
          <h3 v-if="content.title" class="font-weight-bold">{{content.title}}</h3>
          <slot>
            <p v-if="content.subtitle" v-html="content.subtitle"></p>
          </slot>
        </div>
        <div v-if="!authorized" class="d-flex align-items-center justify-content-end">
          <span class="d-flex align-items-center p-3 lock-icon" :class="lockIconClasses" v-html="lockIcon"></span>
        </div>
        <span v-else-if="contentUrl" class="d-flex align-items-center mt-5 cursor-pointer link-label" :class="linkLabelClasses">
          <div v-if="isCustomContent" class="tile-icon-container d-flex justify-content-center align-items-center" :class="content.theme == 'dark' ? 'white' : 'primary'">
            <i :class="iconClass"></i>
          </div>
          <i v-else class="far fa-chevron-right"></i>
          <span class="ml-2">{{buttonTitle}}</span>
        </span>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
[tile-component] {
  grid-row: span 2;
  grid-column: span 2;
  color: var(--theme-color);

  .icon {
    width: auto;
    height: 2.25rem;
    top: 1.5rem;
    right: 1.5rem;
  }
  
  @include media-breakpoint-up(md) {
    .tile__text-section > div {
      max-width: 50%;
    }
  }
  
  @include media-breakpoint-down(sm) {
    min-height: 65vh;
  }

}
</style>